<template>
  <ion-content>
    <ion-button
      fill="clear"
      size="small"
      v-for="reaction in localReactionOptions" v-bind:key="reaction.name"
      @click="reactTheComment(comment, reaction.name)"
    >
      <ion-icon
        slot="icon-only"
        :src="reaction.src"
        :isActive="hasMyReaction(comment, reaction.name)"
      ></ion-icon>
    </ion-button>
  </ion-content>
</template>
<script>
import { IonButton, IonIcon, IonContent } from "@ionic/vue";
import { defineComponent } from "vue";

import { reactComment } from "../../services/apiCall.js";
import { reactionListArray } from "../../services/utils";

export default defineComponent({
  name: "CommentReactionOptions",
  props: ["comment", "parent"],
  components: {
    IonButton,
    IonIcon,
    IonContent,
  },
  data() {
    return {
      reactComment,
      localReactionOptions: reactionListArray,
    };
  },
  methods: {
    hasMyReaction(comment, rtype) {
      if (comment.my_reactions) {
        var hasReaction =
          comment.my_reactions.findIndex((x) => x.reaction_type === rtype) >= 0;
        return hasReaction;
      } else {
        return false;
      }
    },
    reactTheComment(comment, rtype) {
      comment.reaction_count =
        typeof comment.reaction_count !== "undefined"
          ? comment.reaction_count + 1
          : 1;
      reactComment({ comment_id: comment.id, reaction_type: rtype })
        .then((res) => {
          if (res.data.status === 0) {
            comment.reaction_count = res.data.result.reaction_count;
            if (!comment.my_reactions) comment.my_reactions = [];
            var prevReact = comment.my_reactions.findIndex(
              (x) => x.reaction_type === rtype
            );
            if (prevReact < 0) {
              if (comment.my_reactions.length > 0) {
                comment.my_reactions = [];
              }
              comment.my_reactions.push({ reaction_type: rtype });
            } else {
              comment.my_reactions.splice(prevReact, 1);
            }
          }
          this.parent.dismiss();
        })
        .catch((err) => {
          console.log("react comment - err", err);
          this.parent.dismiss();
        });
    },
  },
});
</script>